import * as React from 'react';
import { LoggedIn } from '../../LoggedIn/LoggedIn';
import {
  Header as PackagePickerHeader,
  WixLogo,
} from '@wix/package-picker-components';
import { usePageModeContext } from '../../../providers/PageMode/PageMode.provider';
import { Box } from '@wix/design-system';
import s from './Header.scss';
import classnames from 'classnames';
import { useHeaderContent } from './Content/useHeaderContent';
import { RootStore, withInjectedRootStore } from '../../../providers';
import { Experiments, PurchaseMode } from 'enums';
import { Default } from './Content';

interface HeaderProps {
  rootStore: RootStore;
}

export const HeaderComp: React.FC<HeaderProps> = ({ rootStore }) => {
  const { theme, purchaseMode, isChangePlan } = usePageModeContext();
  const headerContent = useHeaderContent(rootStore);
  const {
    appStore: { experiments },
  } = rootStore;
  const shouldDisplayAnonymousHeader =
    experiments[Experiments.SunriseAnonymousMoneyBackGuarantee] === 'true';
  const isReplaceChangePlanPurchaseModeEnabled =
    experiments[Experiments.ReplaceChangePlanPurchaseMode] === 'true';
  const isUnifiedChangePlanPhase1Enabled =
    experiments[Experiments.UnifiedChangePlanPhase1] === 'true';

  const purchaseModeClassName =
    isReplaceChangePlanPurchaseModeEnabled &&
      isChangePlan &&
      !isUnifiedChangePlanPhase1Enabled
      ? s[PurchaseMode.CHANGE_PLAN]
      : s[purchaseMode];

  const getLogo = () => {
    if (rootStore.appStore.isResellerOffering && rootStore.appStore.resellerOfferingBrandingInfo?.banner) {
      return (
        <Box direction='horizontal' verticalAlign='middle'>
          <img src={rootStore.appStore.resellerOfferingBrandingInfo?.banner} alt='logo' width='154px' height='28px' />
          <Box marginRight="SP1" fontSize="12px" color="#FFFFFF" fontWeight="bold">×</Box>
          <WixLogo skin='light' />
        </Box>);
    }
    return <WixLogo skin='light' />;
  }

  return (
    <LoggedIn>
      {(isLoggedIn) =>
        (isLoggedIn || (!isLoggedIn && shouldDisplayAnonymousHeader)) && (
          <PackagePickerHeader
            className={classnames(s.header, theme, purchaseModeClassName)}
            logo={isLoggedIn && getLogo()}
          >
            <Box
              width='100%'
              align='center'
              flexGrow={1}
              dataHook='header-content'
            >
              {isLoggedIn ? headerContent : <Default />}
            </Box>
          </PackagePickerHeader>
        )
      }
    </LoggedIn>
  );
};

export const Header = withInjectedRootStore(HeaderComp);
